import * as RestApi from 'core/network/RestApi';
import { OffsiteCampaign } from 'models/offsite/Campaign/OffsiteCampaign';
import { generatePath } from 'react-router';
import { OffsiteCampaignEndpoints } from 'sections/offsite-campaigns/constants/api-endpoints';

/*
 * NOTE:
 * Available create options can be found here: https://github.com/SaleCycle/offsite-campaign-api/blob/master/api-requests/create.http
 */

interface BaseCreateOffsiteCampaignRequest {
  siteId: string;
  name: string;
  segments: any[];
}

export interface CreateBulkySendsCampaignRequest extends BaseCreateOffsiteCampaignRequest {
  version: 'v2';
  siteId: string;
  type: 'bulkRetargeting';
  // The campaign state can only be either draft or scheduled in the frontend. It will be updated to other states via the backend.
  state: 'DRAFT' | 'SCHEDULED';
}

export type CreateOffsiteCampaignRequest = CreateBulkySendsCampaignRequest;

export const createOffsiteCampaignMutation = (payload: CreateOffsiteCampaignRequest) => {
  return RestApi.post<OffsiteCampaign, CreateOffsiteCampaignRequest>(
    generatePath(OffsiteCampaignEndpoints.OFFSITE_POST, { siteId: payload.siteId }),
    {
      ...payload,
      segments: [],
    },
  );
};
